import { render, staticRenderFns } from "./ayuda.vue?vue&type=template&id=e7e4a74a"
import script from "./ayuda.vue?vue&type=script&lang=js"
export * from "./ayuda.vue?vue&type=script&lang=js"
import style0 from "./ayuda.vue?vue&type=style&index=0&id=e7e4a74a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports